<template>
    <div v-if="isLogin" class="img-margin">
        <div v-if="profileImagePath"
            class="profile-image"
            :style="{'background-image': `url(${profileImagePath})`}"
            ></div>
        <div v-else
            class="profile-image"
            ></div>
        <input class="input-img-profile"
               type="file"
               ref="inputProfileImage"
               @input="onInputImageProfile($event)"/>
        <div class="upload-file">
            <div class="btn-wrapper">
                <div class="btn-upload" @click="clickSelectImageProfile()">
                    {{ lbl.myprofile.picture.upload_picture}}
                </div>
            </div>
            <div class="hint-file">
                {{ lbl.myprofile.picture.file_support}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
import ResizeImage from '@/helper/ResizeImage.js';
import LocaleMixin from '@/mixin/LocaleMixin';
// service
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
export default {
    name: "ProfilePicture",
    mixins: [LocaleMixin],
    data: function() {
        return {
            isLogin: false,
            profileImagePath: "",
            bzbConfig: Vue.bzbsConfig,
            fileImage: "",
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            if (status) {
                this.profileImagePath = this.getUrlProfileImage();
            }
        });
    },
    mounted: function() {
        // Account.loginStatus().then((status) => {
        //     this.isLogin = status;
        //     if (status) {
        //         this.profileImagePath = this.getUrlProfileImage();
        //     }
        // });
    },
    methods: {
        clickSelectImageProfile: function() {
            this.$refs["inputProfileImage"].click();
        },
        onInputImageProfile: function(event) {
            var fileInput = event.srcElement.files[0];

            if (this.checkFileCondition(fileInput)) {
                this.flowUploadImage(fileInput);
                this.fileImage = fileInput;
            } else {
                this.resizePicture(fileInput, (fileResize) => {
                    this.flowUploadImage(fileResize);
                    this.fileImage = fileResize;
                });
            }
            this.$emit('uploadImage',true)
        },
        flowUploadImage: function(file) {
            this.showLoading();
            var fileReader = new FileReader();
            fileReader.onload = (e) => {
                this.profileImagePath = e.target.result;
            };
            fileReader.readAsDataURL(file);
        },
        onUploadImage: function() {
            this.uploadImpageProfile(this.fileImage);
        },
        resizePicture: function(fileImage, callback) {
            var resizeImage = new ResizeImage();
            resizeImage.resize(fileImage, (fileResize) => {
                callback(fileResize);
            });
        },
        checkFileCondition: function(file) {
            // console.log(file);
            if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
                console.log('file type not allow');
                return false;
            }
            if (file.size > 4048576) { // limit 4 MB
                console.log('file size too large');
                return false;
            }
            return true;
        },
        uploadImpageProfile: function(fileImage) {
            var token = Account.getToken();
            BzbsProfile.updateProfile(token, null, null, null, "data", fileImage).subscribe((data) => {
                console.log(data);
                this.hideLoading();
            }, (err) => {
                console.log(err);
                this.hideLoading();
            });
        },
        getUrlProfileImage: function() {
            const userId = Account.getCacheUser().userId;
            const token = Account.getToken();
            const currentTime = new Date().getTime();
            var imageUrl = ConfigManager.getApiUrl() + `/profile/${userId}/picture?type=large&token=${token}&time=${currentTime}`;
            return imageUrl;
        },

        //#region function
        showLoading: function() {
            // this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            // this.busModal.$emit('hideLoadingModal', {});
        },
        //#endregion function
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .profile-image {
        background-image: url("../../../assets/icon/user-profile.png");
        border-radius: 50%;
        width: 100px;
        height: 100px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-color: #aaa;
        // margin: auto;
        cursor: pointer;
    }
    .input-img-profile {
        display: none;
    }
    .img-margin {
        display: flex;
    }
    .upload-file{
        margin: 20px;
    }
    .btn-wrapper {
        border: 1px solid  $main-orange-color;
        border-radius: 10px;
        height: 30px;
        text-align: center;
        margin-bottom: 10px;
        cursor: pointer;
    }
    .btn-upload {
        font-size: 16px;
        color: $main-orange-color;
        font-family: 'PRT-Medium';
        padding: 2px 23px;
    }
    .hint-file{
        font-size: 14px;
        color: $a-black-333333;
        font-family: 'PRT-Regular';
    }
</style>
